import { Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAddNewProfileDialog extends Layout {
    panelAddNewProfile: Panel;
    textboxDirection: Textbox;
    textboxTemplate: Textbox;
    textboxTransactionType: Textbox;
}
